import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import AppCard from './AppCard'
import { makeStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import appCollection from '../data/apps.json'

const useStyles = makeStyles({
  root: {
    '& h2': {
      marginBottom: '40px'
    },
    '& h3': {
      marginBottom: '15px',
    }
  }
})

const Menu = (props) => {
  const { t, location, notificationIsActive } = props
  const classes = useStyles()

  useEffect(() => {
    document.title = `City of Seattle | ${t('appMenu')}`
  }, [t])

  useEffect(() => { 
    if (!notificationIsActive && location.state !== undefined && location.state.notification !== undefined) {
      props.showNotification(location.state.notification)
    }
  })

  return (
    <div className={classes.root}>
      {appCollection.map((collection, i) => (
        <div key={i}>
          <h3>{collection.categoryName}</h3>
          <AppCard apps={collection.apps} />
        </div>
      ))}
    </div>
  )
}

const AppMenu = withRouter(Menu)

export default withTranslation()(AppMenu)